import script from "./SecSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SecSection.vue?vue&type=script&setup=true&lang=js"

import "./SecSection.vue?vue&type=style&index=0&id=e4df5dbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4df5dbc"]])

export default __exports__